import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'attachmentType',
})
export class AttachmentTypePipe implements PipeTransform {
  attachmentType: string = '';

  /**
   * When we call this pipe it's come to this method transform by default
   * and validated the given param number and return the right attachment File translation key as string.
   * @param value the attachment type number .
   * @param args
   * @returns attachmentType string translation key  .
   */
  transform(value: unknown, ..._args: unknown[]): string {
    switch (value) {
      case 1: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.SOURCE_DOCUMENT';
        return this.attachmentType;
      }

      case 2: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.SOURCE_DOCUMENT_FROM_CONTROLLER';
        return this.attachmentType;
      }

      case 3: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TRANSLATION_CANDIDATE';
        return this.attachmentType;
      }

      case 4: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.TRANSLATION';
        return this.attachmentType;
      }

      case 5: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.CUSTOMER_INVOICE';
        return this.attachmentType;
      }

      case 6: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.TRANSLATOR_INVOICE';
        return this.attachmentType;
      }

      case 7: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_CUSTOMER_INVOICE';
        return this.attachmentType;
      }

      case 8: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.ANNULATION_INVOICE';
        return this.attachmentType;
      }

      case 9: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.ANNULATION_INVOICE_TEMPLATE';
        return this.attachmentType;
      }

      case 10: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.OFFER';
        return this.attachmentType;
      }

      case 11: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_TRANSLATION';
        return this.attachmentType;
      }

      case 12: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_TRANSLATION_CANDIDATE';
        return this.attachmentType;
      }

      case 13: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.ADDITIONAL_INFO_FROM_CUSTOMER';
        return this.attachmentType;
      }

      case 14: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.ADDITIONAL_INFO_FROM_CONTROLLER';
        return this.attachmentType;
      }

      case 15: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.PUBLIC_ADDITIONAL_INFO_FROM_CUSTOMER';
        return this.attachmentType;
      }

      case 16: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.TRANSLATOR_CREDIT';
        return this.attachmentType;
      }

      case 17: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TRANSLATOR_CANCELLATION_CREDIT';
        return this.attachmentType;
      }

      case 18: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_TRANSLATOR_CREDIT';
        return this.attachmentType;
      }

      case 19: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.PROOFREADING_CANDIDATE';
        return this.attachmentType;
      }

      case 20: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_PROOFREADING_CANDIDATE';
        return this.attachmentType;
      }

      case 21: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.PROOFREADER_INVOICE';
        return this.attachmentType;
      }

      case 22: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_PROOFREADING';
        return this.attachmentType;
      }

      case 23: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.PROOFREADING';
        return this.attachmentType;
      }

      case 24: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.PROOFREADER_CREDIT';
        return this.attachmentType;
      }

      case 25: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.PROOFREADER_CANCELLATION_CREDIT';
        return this.attachmentType;
      }

      case 26: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_PROOFREADER_CREDIT';
        return this.attachmentType;
      }

      case 27: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.TRANSREADER_CREDIT';
        return this.attachmentType;
      }

      case 28: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TRANSREADER_CANCELLATION_CREDIT';
        return this.attachmentType;
      }

      case 29: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_TRANSREADER_CREDIT';
        return this.attachmentType;
      }

      case 30: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TRANSLATION_ATTESTATION';
        return this.attachmentType;
      }

      case 31: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.COLLECTIVE_TRANSLATIONS';
        return this.attachmentType;
      }

      case 32: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TRADOS_PROJECT_TEMPLATE';
        return this.attachmentType;
      }

      case 33: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.TRADOS_PROJECT';
        return this.attachmentType;
      }

      case 34: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TRADOS_PACKAGE_TRANSLATOR';
        return this.attachmentType;
      }

      case 35: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TRADOS_RETURN_PACKAGE_TRANSLATOR';
        return this.attachmentType;
      }

      case 36: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TRADOS_PACKAGE_PROOFREADER';
        return this.attachmentType;
      }

      case 37: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TRADOS_RETURN_PACKAGE_PROOFREADER';
        return this.attachmentType;
      }

      case 38: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.TARGET_TRANSLATION';
        return this.attachmentType;
      }

      case 39: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TARGET_TRANSLATION_CANDIDATE';
        return this.attachmentType;
      }

      case 40: {
        // this.attachmentType ="ATTACHMENTS.ATTACHMENTS_TYPE.OLD_TARGET_TRANSLATION";
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.COLLECTIVE_TRANSLATIONS';
        return this.attachmentType;
      }

      case 41: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_TARGET_TRANSLATION_CANDIDATE';
        return this.attachmentType;
      }

      case 42: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TARGET_TRANSLATOR_CREDIT';
        return this.attachmentType;
      }

      case 43: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.TARGET_TRANSLATOR_CANCELLATION_CREDIT';
        return this.attachmentType;
      }

      case 44: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_TARGET_TRANSLATOR_CREDIT';
        return this.attachmentType;
      }

      case 45: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.INTERMEDIATE_TRANSLATION';
        return this.attachmentType;
      }

      case 46: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.INTERMEDIATE_TRANSLATION_CANDIDATE';
        return this.attachmentType;
      }

      case 47: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_INTERMEDIATE_TRANSLATION';
        return this.attachmentType;
      }

      case 48: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_INTERMEDIATE_TRANSLATION_CANDIDATE';
        return this.attachmentType;
      }

      case 49: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.INTERMEDIATE_TRANSLATOR_CREDIT';
        return this.attachmentType;
      }

      case 50: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.INTERMEDIATE_TRANSLATOR_CANCELLATION_CREDIT';
        return this.attachmentType;
      }

      case 51: {
        this.attachmentType =
          'ATTACHMENTS.ATTACHMENTS_TYPE.OLD_INTERMEDIATE_TRANSLATOR_CREDIT';
        return this.attachmentType;
      }

      case 52: {
        this.attachmentType = 'ATTACHMENTS.ATTACHMENTS_TYPE.UPDATE_TM_ANALYSIS';
        return this.attachmentType;
      }
    }
    return this.attachmentType;
  }
}
